import $ from "jquery";

export default class City {
    static instance = null;

    constructor(el) {
        this.$el = $(el)
        this.cityName = this.$el.data('city')
        this.geo = this.$el.data('geo')
        this.region = this.$el.data('region')
        this.api = this.$el.data('api')
        this.cityData = null
        this.init()
        City.instance = this;
    }
    init() {
        this.$el.on('click', (e) => {
            e.preventDefault()
            const self = this;
            if ($(e.currentTarget).hasClass('acco__link')) {
                $('.acco__link').removeClass('current')
                $(e.currentTarget).addClass('current')
                $(e.currentTarget).parents('.acco').find('.acco__trigger').text($(e.currentTarget).text())
            }

            $.ajax({
                type:'GET',
                url: self.api,
                dataType:'json',
                data:{
                    city: self.cityName,
                    region: self.region,
                    geo: self.geo
                },
                success: function (data) {
                    if (data.success) {
                        const html = self.generateTemplate(data.data)
                        const contactsContainer = document.querySelector('.contacts__main')
                        contactsContainer.innerHTML = html
                        self.initMap()
                    }
                },
                error: function (data) {
                    console.log(data)
                }
            });
        })
    }

    initMap(){
        ymaps.ready(function () {
            $('.contacts__map').each(function () {
                const id = this.id;
                const coords = $(this).attr('data-coords').split(',');
                const myMap = new ymaps.Map(id, {
                    center: coords,
                    controls: ['zoomControl'],
                    zoom: 12,
                });
                const myPlacemark = new ymaps.Placemark(coords, {}, {
                    iconLayout: 'default#image',
                    iconImageHref: ' /local/templates/rima/front/build/assets/img/pin.png',
                    iconImageSize: [20, 35],
                    iconImageOffset: [-10, -35]
                });
                myMap.geoObjects.add(myPlacemark);
            });
        })
    }

    generateTemplate(data) {
        const getShopCardHtml = (item) => {
            const {name, code, coords, address, phone, email} = item

            return `<div class="contacts__block">
                <div class="contacts__map" id="${code}" data-coords="${coords}"></div>
                <div class="contacts-card">
                  <h3 class="contacts-card__title">${name}</h3>
                  <address class="contacts-card__address">${address}</address>
                  <p class="contacts-card__links">
                      <a class="contacts-card__link" href="tel:${phone}">${phone}</a>
                      <a class="contacts-card__link" href="mailto:${email}">${email}</a>
                  </p>
                  <div class="contacts-card__btn-wrap">
                    <a class="button button--main button--large" href="mailto:${email}">Отправить запрос</a>
                  </div>
                </div>
              </div>
    `.trim()}

        return `${data.map(item => getShopCardHtml(item)).join('').trim()}`
    }
}
